export default __webpack_public_path__ + "static/media/unapproved-price.aaa24d5a.svg";